import React from 'react';

function AddressBlock(title,data1){
	return(
		<address>
			<strong>{title}</strong><br/>
			{data1}
		</address>
	)
}

function Contact() {
	return(
		<section class="section-contact section-wrapper gray-bg">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-12">
						<div class="section-title">
							<h2>Contact</h2>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-12">
						{
							// AddressBlock('Address','4-36/1, Quthbullapur, Hyderabad, Telangana, India, Pin: 500055')
						}
						{
							// AddressBlock('Phone','+91 8712965092')
						}
						{
							AddressBlock('Email','veduruvadauday@gmail.com')
						}
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<div class="feedback-form">
							<h2>Get in touch</h2>

							<form id="contactForm" action="sendemail.php" method="POST">
								<div class="form-group">
									<label for="InputName">Name</label>
									<input type="text" name="name" required="" class="form-control" id="InputName"
										placeholder="Full Name"/>
								</div>
								<div class="form-group">
									<label for="InputEmail">Email address</label>
									<input type="email" name="email" required="" class="form-control" id="InputEmail"
										placeholder="Email"/>
								</div>
								<div class="form-group">
									<label for="InputSubject">Subject</label>
									<input type="text" name="subject" class="form-control" id="InputSubject"
										placeholder="Subject"/>
								</div>
								<div class="form-group">
									<label for="message-text" class="control-label">Message</label>
									<textarea class="form-control" rows="4" required="" name="message" id="message-text" placeholder="Write message"></textarea>
								</div>

								<button type="submit" class="btn btn-primary">Submit</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Contact;